export default "__VITE_ASSET__b6443737__"